const BaseStateDefault = {
    requesting: false,
    list: []
  }
  
  export default BaseStateDefault
  